// src/services/adminDatabaseBackupService.js
import axios from "axios";
import { getToken } from "../../auth/authService";

const api = axios.create({
 baseURL: process.env.REACT_APP_BASE_URL,
 headers: {
 Authorization: `Bearer ${getToken()}`,
 },
 responseType: "blob", // IMPORTANT for file download
});

/* ===============================
 ADMIN DATABASE BACKUP
================================ */

/**
 * Admin: Download database backup
 * Streams backup file directly from backend
 */
export const downloadDatabaseBackupAdmin = () =>
 api.get("/admin/download-backup");
